import React from 'react'

const AngularIcon = ({ height, width, color }: { height: string, width: string, color: string }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.3592 52.4268H57.6406L50 34.0568L42.3592 52.4268ZM50 5.07812L8.32715 19.9988L14.7045 75.2881L50 94.9215L85.2953 75.2881L91.6729 19.9988L50 5.07812ZM76.1109 73.6242H66.3641L61.1102 60.5084H38.9299L33.6754 73.6242H23.9092L50 15.0051L76.1109 73.6242Z" fill="#DD0031" />
        </svg>
    )
}

export default AngularIcon